import React from 'react';
import { type SmartScrollbarIndicatorConfig } from './SmartScrollbar';

/**
 * Default scroll-position indicator: a long, wide, high-contrast "grip" handle.
 *
 * It is intentionally large — tall along the scroll axis (`totalHeight`) and
 * wide across the rail (`totalWidth`) — so it reads as a proper grab handle and
 * is easy to drag on touch / small-screen devices. (`totalWidth` also widens
 * the scrollbar's pointer hit-zone.) The three grip lines signal draggability.
 */
const INDICATOR_COLOR = 'hsl(var(--primary))';
const BORDER_COLOR = 'hsl(var(--background) / 0.9)';
const GRIP_COLOR = 'hsl(var(--primary-foreground) / 0.9)';
const TOTAL_WIDTH = 30;
const TOTAL_HEIGHT = 48;

function DefaultIndicator() {
  const cx = TOTAL_WIDTH / 2;
  const cy = TOTAL_HEIGHT / 2;
  const gripHalf = 5;
  return (
    <svg
      width={TOTAL_WIDTH}
      height={TOTAL_HEIGHT}
      viewBox={`0 0 ${TOTAL_WIDTH} ${TOTAL_HEIGHT}`}
    >
      <rect
        x={1}
        y={1}
        width={TOTAL_WIDTH - 2}
        height={TOTAL_HEIGHT - 2}
        rx={(TOTAL_WIDTH - 2) / 2}
        ry={(TOTAL_WIDTH - 2) / 2}
        fill={INDICATOR_COLOR}
        stroke={BORDER_COLOR}
        strokeWidth={1.5}
      />
      <g
        stroke={GRIP_COLOR}
        strokeWidth={1.6}
        strokeLinecap="round"
      >
        <line x1={cx - gripHalf} y1={cy - 4} x2={cx + gripHalf} y2={cy - 4} />
        <line x1={cx - gripHalf} y1={cy} x2={cx + gripHalf} y2={cy} />
        <line x1={cx - gripHalf} y1={cy + 4} x2={cx + gripHalf} y2={cy + 4} />
      </g>
    </svg>
  );
}

export const DEFAULT_INDICATOR_CONFIG: SmartScrollbarIndicatorConfig = {
  totalWidth: TOTAL_WIDTH,
  totalHeight: TOTAL_HEIGHT,
  renderIndicator: (_react: typeof React) => <DefaultIndicator />,
};
